export default __webpack_public_path__ + "static/media/01_anis.8706e716.gif";